export async function crearSmartlink(payload, endpoint) {
  const apiUrl = `${process.env.REACT_APP_API_URL_DEV }${endpoint}`;
  

  let rawToken = localStorage.getItem('access_token') || "";
  const access_token = rawToken.replace(/['"]+/g, '');

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${access_token}`
    },
    body: JSON.stringify(payload)
  });
  
  if (!response.ok) {

    const errorData = await response.json().catch(() => ({ 
      error: 'Error sin detalles en el cuerpo de la respuesta.'
    }));
    

    throw new Error(errorData.error || `Error HTTP: ${response.status}`);
  }

  const data = await response.json();
  return data;
}